import React from 'react';

const Merch = () => {
  // Merch disabled - returning null
  return null;
};

export default Merch;
